export class ArrayUtils {
  static includesAny<T>(arr1: Array<T> | undefined, arr2: Array<T> | undefined): boolean {
    return arr2?.some((a2) => arr1?.includes(a2)) || false;
  }
}
